import config from './config';
import api from '@/api';
import store from '../store';

export default {
    /*登录*/
    async init(that, callback) {
        callback();
        return
        const user = this;
        if (that.userInfo && !isAgain) {
            that.$common.callback(callback, that.userInfo);
            return
        }
        //微信授权登录
        const [loginErr, loginRes] = await uni.login();
        const res = await api.wxlogin({
            code: loginRes.code,
        });
        console.log('res', res);
        if (res.data.openid) {
            //登录成功
            console.log('登录成功');
            let userInfo = res.data;
            userInfo = that.$user.normalFilter(userInfo);
            store.dispatch('setUserInfo', userInfo);
            that.$common.callback(callback, userInfo);
            // user.loginAfter();
        }
    },
    async userInfo(that) {
        const user = this;
        const res = await that.$api.userInfo({
            openid: that.userInfo.openid,
        })
        return new Promise((qres, qrej) => {
            if (res.data.status == that.$config.RESOK) {
                let userInfo = res.data.data;
                // userInfo = that.$user.normalFilter(userInfo);
                //  store.dispatch('setUserInfo', userInfo);
                qres(userInfo)
            } else {
                qres(null)
            }
        })
    },
    async loginAfter() {
        console.log('loginAfter')
        const pages = getCurrentPages();
        const page = pages[pages.length - 1];
        if (config.TABBAR.includes(page.route)) {
            const notRes = await api.noticeStatus({
                user_details_id
            });
            if (notRes.data.status == config.RESOK) {
                uni.showTabBarRedDot({
                    index: 2
                })
            } else {
                uni.hideTabBarRedDot({
                    index: 2
                })
            }
        }
    },
  /*过滤*/
    normalFilter(userInfo) {
        if(userInfo.type == config.USER_TYPE.ENTER ){
            userInfo.logo = ~userInfo.logo.indexOf('http') ? userInfo.logo : config.upPrefix + userInfo.logo;
        }
        return userInfo
    },
}
